import { LOADING_DATA_ON_PAGE_LOAD } from "../../../modules/savedItems/constants";
import {
  CLEAR_PERSISTENT_ERRORS,
  INITIALISED
} from "../../../modules/common/constants";
import attemptSetup from "./attemptSetup";

export const initialise = () => async dispatch => {
  const [getUserIdentityPromise] = await attemptSetup(dispatch);
  dispatch({ type: CLEAR_PERSISTENT_ERRORS });
  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: false });
  await getUserIdentityPromise;
  dispatch({ type: INITIALISED });
};
